// @ts-nocheck
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import ChevronLeft from "@store/Library/Components/Toolkit/Icons/ChevronLeft";
import ChevronRight from "@store/Library/Components/Toolkit/Icons/ChevronRight";
import DoubleChevronLeft from "@store/Library/Components/Toolkit/Icons/DoubleChevronLeft";
import DoubleChevronRight from "@store/Library/Components/Toolkit/Icons/DoubleChevronRight";
import { productListPaginationWrapperStyles } from "@store/Themes/common/mixins/productList";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { buttonResetProps } from "@store/Themes/common/props/button";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { iconScalableStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const itemStyles = () => {
    return css`
        display: flex;
        justify-content: center;
        min-width: ${pxToRem(32)};
        width: auto !important; /* Override breakpoint widths */
        height: ${pxToRem(32)};
        padding: ${pxToRem(0, 6)};
        margin: 0;
        border-radius: 50%; /* Store Custom Code */
        font-size: ${x => x.theme.design.typography.size.smaller};
        font-weight: ${x => x.theme.design.typography.weight.bold};
        color: ${getColor("text")};
        transition: ${transitionHoverStyles("color", "background-color")};
    `;
};

const pagination: Styleguide["pagination"] = {
    defaultProps: {
        hidePerPageSelect: true,
        hideSinglePage: true,
        navIconsSrc: {
            firstPage: DoubleChevronLeft,
            previousPage: ChevronLeft,
            nextPage: ChevronRight,
            lastPage: DoubleChevronRight,
        },
        cssOverrides: {
            pagination: css`
                ${productListPaginationWrapperStyles()}
            `,
            currentButton: css`
                background-color: ${getColor("primary")};
                color: ${getColor("primary.contrast")};
            `,
            ellipsis: css`
                ${itemStyles()}
                font-size: ${pxToRem(22)};
                line-height: ${pxToRem(20)};
                cursor: default;
                color: ${getColor("text.accent")};
            `,
            linkList: css`
                ul {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    justify-content: center;
                    gap: ${pxToRem(4)};

                    ${breakpoint(360, "down")} {
                        /* Make sure the pagination does not overflow on very small displays */
                        gap: ${pxToRem(2)};
                    }
                }
            `,
            perPageSelect: css`
                &:not(#important) /* Override breakpoint values */ {
                    width: auto;
                    margin-right: 1em;
                    margin-left: 1em;
                }
            `,
        },
        buttonProps: {
            ...buttonResetProps,
            css: css`
                ${buttonResetProps.css}
                ${itemStyles()}
                align-items: center;
                background-color: ${getColor("common.accent")};

                ${IconWrapper} {
                    ${iconScalableStyles("1.1em")}
                    justify-content: center;
                    color: ${getColor("primary")};
                    top: 0;
                }

                &:disabled {
                    background-color: ${getColor("common.accent")};
                    color: ${getColor("text.disabled")};

                    ${IconWrapper} {
                        color: inherit;
                    }
                }

                &:not(:disabled) {
                    &:hover,
                    &:active {
                        background-color: ${getColor("primary")};
                        color: ${getColor("primary.contrast")};

                        ${IconWrapper} {
                            color: inherit;
                        }
                    }
                }
            `,
        },
        selectProps: {
            sizeVariant: "xsmall" as any,
            cssOverrides: null as any,
            labelProps: null as any,
        },
    },
};

export default pagination;
